module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "dark": "",
      "stateless": false,
      "app": ""
    },
    model: {
      value: (_vm.$store.state.toggle),
      callback: function($$v) {
        _vm.$set(_vm.$store.state, "toggle", $$v)
      },
      expression: "$store.state.toggle"
    }
  }, [_c('div', {
    staticClass: "sidenav-app",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$store.commit('toggleSidenav')
      }
    }
  }, [_c('h1', [_c('span', [_vm._v(_vm._s(_vm.$t('app.title')))])])]), _vm._v(" "), _c('div', {
    staticClass: "sidenav-user"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('div', {
    staticClass: "sidenav-user__photo"
  }, [_vm._v(_vm._s(_vm.inicial))])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('div', {
    staticClass: "sidenav-user__name"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("person_pin")]), _vm._v("\n          " + _vm._s(_vm.nombreCompleto) + "\n        ")], 1), _vm._v(" "), _c('div', {
    staticClass: "sidenav-user__entidad"
  }, [_c('v-icon', {
    attrs: {
      "dark": ""
    }
  }, [_vm._v("location_city")]), _vm._v("\n          " + _vm._s(_vm.user.entidad)), _c('br'), _c('strong', [_vm._v(_vm._s(_vm.user.rol))])], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "sidenav-user__email"
  }, [_vm._v("\n      @" + _vm._s(_vm.user.usuario) + "\n    ")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": "",
      "id": "sidenav-menu"
    }
  }, [_vm._l((_vm.menu), function(item, i) {
    return [(item.submenu) ? _c('v-list-group', {
      attrs: {
        "no-action": ""
      },
      model: {
        value: (item.model),
        callback: function($$v) {
          _vm.$set(item, "model", $$v)
        },
        expression: "item.model"
      }
    }, [_c('v-list-tile', {
      attrs: {
        "slot": "item",
        "data-url": item.url
      },
      on: {
        "click": function($event) {
          return _vm.send(item.url, item.submenu)
        }
      },
      slot: "item"
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "warning"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(_vm.getLabel(item)) + "\n            ")]), _vm._v(" "), _c('v-icon', [_vm._v(_vm._s(item.model ? 'keyboard_arrow_down' : 'keyboard_arrow_right'))])], 1)], 1), _vm._v(" "), _vm._l((item.submenu), function(child, i) {
      return _c('v-list-tile', {
        key: i,
        attrs: {
          "data-url": child.url
        },
        on: {
          "click": function($event) {
            return _vm.send(child.url)
          }
        }
      }, [(child.icon) ? _c('v-list-tile-action', [_c('v-icon', [_vm._v(_vm._s(child.icon))])], 1) : _vm._e(), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n              " + _vm._s(_vm.getLabel(child)) + "\n            ")])], 1)], 1)
    })], 2) : _c('v-list-tile', {
      attrs: {
        "data-url": item.url
      },
      on: {
        "click": function($event) {
          return _vm.send(item.url, item.submenu)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "warning"
      }
    }, [_vm._v(_vm._s(item.icon))])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("\n            " + _vm._s(_vm.getLabel(item)) + "\n          ")])], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-408c4325","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/common/layout/AppSidenav.vue
// module id = 512
// module chunks = 2